export enum TravellerTypes {
	PersonalDetails,
	CompanionEmpty,
	CompanionFilled
}
